module.exports = __webpack_public_path__ + "media/images/gm_icon05_on-91cc3606633d4e71f12a7251e2a0ffa0.png";